import React, { Component } from 'react';
import Button from 'screens/components/basic/Button';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import CheckInput from 'screens/components/basic/CheckInput';

class Socialmedia extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
                <div>
                    <CardSimple>
                        <h4 className="ml-1 mb-2">LOGIN PAGE</h4>
                        <div className="row pl-2">
                            <CheckInput 
                                name="facebookLogin"
                                text="Facebook Login"
                                value="facebookLogin"
                            />  
                            <CheckInput 
                                name="googleLogin"
                                text="Google+ Login"
                                value="googleLogin"
                            /> 
                        </div> {/* .row */}
                        <h4 className="ml-1 mb-2 mt-3">BLOG PAGE</h4>
                        <div className="row pl-2">
                            <CheckInput 
                                name="twitterShare"
                                text="Twitter Share"
                                value="twitterShare"
                            />  
                            <CheckInput 
                                name="facebookShare"
                                text="Facebook Share"
                                value="facebookShare"
                            /> 
                        </div> {/* .row */}
                    </CardSimple>  
                    <br />
                    <div className="row">
                        <div className="col-lg-12">
                            <Button name="buttonSave"
                                className="pull-right"
                                label={LOOKUP.menu.admin.coupon.controls.saveButton}
                                primary={true} />
                            <Button name="buttonCancel"
                                className="pull-right btn-space"
                                label={LOOKUP.common.cancel.text} />
                        </div> {/* .col */}
                    </div> {/* .row */}
                </div> 
        );
    }
}


export default Socialmedia;